import cloneDeep from 'clone-deep'
import { IVisibleProp } from 'config'
import { propertyStateChecklist, togglePropertyStateVisible } from 'config/propertyStateOptions'
import { useMemo } from 'react'
import { Checkbox } from 'stories/components'
import type { ISelectOption } from 'stories/components/SelectOptionInputs/types'

export const StateChoices = ({
  data,
  setData,
}: {
  data: IVisibleProp
  setData: (data: IVisibleProp) => void
}) => {
  const checklist = useMemo(
    () => propertyStateChecklist(data.options as ISelectOption[] | undefined),
    [data.options],
  )

  const onToggle = (key: string, checked: boolean) => {
    const next = cloneDeep(data)
    next.options = togglePropertyStateVisible(data.options as ISelectOption[] | undefined, key, checked) as any
    setData(next)
  }

  return (
    <div className="grid gap-2">
      <p className="font-bold text-sm">States in Dropdown</p>
      <p className="text-xs text-gray-500">
        Checked states appear on the loan State dropdown. Uncheck a state your company does not lend in.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-3 gap-y-1 max-h-72 overflow-y-auto border border-gray-200 rounded-lg p-3">
        {checklist.map((opt) => {
          const checked = opt.visible !== false
          return (
            <Checkbox
              key={opt.key}
              id={`property-state-${opt.key}`}
              title={opt.title}
              value={checked}
              onChange={(value: boolean) => onToggle(opt.key, value)}
            />
          )
        })}
      </div>
    </div>
  )
}
